/**
 * Itinerary fare for booking history/details (amount + commission).
 * Prefer API-computed display_* fields; fall back to local calculation.
 */

function parseAmount(value) {
  const parsed = parseFloat(value ?? 0);
  return Number.isFinite(parsed) ? parsed : 0;
}

function applyCommission(base, commissionFeePercent) {
  const commission =
    Number.isFinite(Number(commissionFeePercent)) && Number(commissionFeePercent) >= 0
      ? Number(commissionFeePercent)
      : 5;
  return Math.round((base + (base * commission) / 100) * 100) / 100;
}

function isFreeRebookingLeg(leg) {
  const paymentMethod = (leg.payment_method || '').toLowerCase();
  const transactionId = String(leg.transaction_id || '').toUpperCase();
  return paymentMethod === 'free' || transactionId.startsWith('FREE_REBOOKING');
}

export function getBookingLegItineraryTotal(leg, commissionFeePercent) {
  if (leg?.display_total_fare != null) {
    return parseAmount(leg.display_total_fare);
  }

  const amount = parseAmount(leg?.amount);
  const paid = parseAmount(leg?.paid_total_amount);
  const promoDiscount = parseAmount(leg?.promo_discount_amount);
  const changeFee = parseAmount(leg?.flight_change_fee_paid);
  const changeFare = parseAmount(leg?.change_fare_paid);
  const commission = commissionFeePercent ?? leg?.commission_fee;

  if (leg?.parent_booking_id) {
    return Math.round((changeFee + changeFare) * 100) / 100;
  }

  if (isFreeRebookingLeg(leg) && amount > 0) {
    return applyCommission(amount, commission);
  }

  if (promoDiscount > 0 && paid > 0) {
    return paid;
  }

  if (amount > 0 && paid > 0) {
    if (paid >= amount) return Math.round((paid + changeFee + changeFare) * 100) / 100;
    if (changeFee > 0 || changeFare > 0) {
      return Math.round((paid + changeFee + changeFare) * 100) / 100;
    }
    return applyCommission(amount, commission);
  }

  if (amount > 0) return applyCommission(amount, commission);
  return Math.round((paid + changeFee + changeFare) * 100) / 100;
}

export function getBookingLegFarePerPax(leg, commissionFeePercent) {
  if (leg?.display_fare_per_pax != null) {
    return parseAmount(leg.display_fare_per_pax);
  }

  if (leg?.display_price != null) {
    return parseAmount(leg.display_price);
  }

  const total = getBookingLegItineraryTotal(leg, commissionFeePercent);
  const passengers = Math.max(1, parseInt(leg?.passenger_count ?? 1, 10) || 1);
  return Math.round((total / passengers) * 100) / 100;
}
